import { render, staticRenderFns } from "./LogisticsBlock.vue?vue&type=template&id=10a3ab2d&scoped=true"
import script from "./LogisticsBlock.vue?vue&type=script&lang=js"
export * from "./LogisticsBlock.vue?vue&type=script&lang=js"
import style0 from "./LogisticsBlock.vue?vue&type=style&index=0&id=10a3ab2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3ab2d",
  null
  
)

export default component.exports